import React, { useMemo } from 'react';
import { Typography } from 'antd';
import { sortBy } from 'lodash';
import useColors from "../hooks/useColors";
import './BarTable.css';
import {toRGB} from "../utils/colorUtils";

const BarTable = ({ data, title, normalize = false, interpolateFunction=null }) => {
  // Sort data in descending order
  const sortedData = useMemo(() => sortBy(data, (item) => -item.value), [data]);

  // Calculate the maximum value in the data for normalization
  const maxDomain = Math.max(...data.map(d => d.value));

  // Generate colors based on the number of bars
  const colors = useColors({
    interpolateFunction,
    numberOfShades: sortedData.length,
    minDomain: 0.2,
    maxDomain
  });

  return (
    <div className="allocation-table">
      <Typography.Title level={5} style={{ paddingLeft: '10px', fontWeight: 600 }}>{title}</Typography.Title>
      <table className="allocation-table-content">
        <tbody>
          {sortedData.map((item, index) => {
            // Normalize the bar width if the normalize prop is true
            const normalizedValue = normalize ? (item.value / maxDomain) * 100 : item.value;
            const barColor = colors[index];

            return (
              <tr key={index} className="allocation-row">
                <td className="label-column">
                  <Typography.Text style={{ fontSize: '0.8rem', textTransform: 'capitalize' }}>
                    {item.label}
                  </Typography.Text>
                </td>
                <td className="percentage-column">
                  <Typography.Text style={{ fontSize: '0.8rem', fontWeight: '500', whiteSpace: 'nowrap' }}>
                    {typeof item.value === 'number' && item.value.toFixed(2)}%
                  </Typography.Text>
                </td>
                <td className="bar-chart-column">
                  <div className="bar-background">
                    <div
                      className="bar-fill"
                      style={{
                        width: `${normalizedValue}%`,
                        backgroundColor: barColor,
                        boxShadow: `3px 3px 3px ${toRGB(barColor, 0.3)}`, // Custom shadow based on bar color
                      }}
                    >
                      <div className="marker-line" style={{ left: `${normalizedValue}%` }} />
                    </div>
                    <div className="bar-full"></div>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BarTable;
